const getTenantId = () => {
  const hostname = window.location.hostname;
  return hostname.startsWith("localhost") ? "stage" : hostname.split(".")[0];
};

export default getTenantId;
